const namespace = 'Investor_';

export const INVESTOR_ADD_NEW_BORROWER = `${namespace}AddNewBorrower`;
export const INVESTOR_INVITE_BORROWER = `${namespace}InviteBorrower`;
export const INVESTOR_VIEW_REPORT = `${namespace}ViewReport`;
export const INVESTOR_OPEN_TAB = `${namespace}OpenTab`;
export const INVESTOR_DOWNLOAD_DATA = `${namespace}DownloadData`;
export const INVESTOR_CB_ADD_OFFICIAL = `${namespace}CB_AddOfficial`;
export const INVESTOR_CB_SUBMIT_REPORT = `${namespace}CB_SubmitReport`;
export const INVESTOR_CB_OPEN_COMBINED_REPORT = `${namespace}CB_OpenCombinedReport`;
export const INVESTOR_CB_OPEN_FULL_REPORT = `${namespace}CB_OpenFullReport`;
export const INVESTOR_COMPANY_ACCOUNT_CREATED = `${namespace}CompanyAccountCreated`;
export const INVESTOR_HOME_PAGE_VIEW = `${namespace}HomePageView`;
export const INVESTOR_LOG_IN = `${namespace}LogIn`;
export const INVESTOR_LOG_OUT = `${namespace}LogOut`;
export const INVESTOR_COPY_INVITE_LINK = `${namespace}CopyInviteLink`;
export const INVESTOR_DOWNLOAD_CIBIL_QUERY = `AICA_BureauQuery_Downloaded`;
export const INVESTOR_CLICK_ALERTS = `${namespace}AlertsClicked`;
export const INVESTOR_CLOSE_ALERTS = `${namespace}AlertsClosed`;
export const INVESTOR_CHATBOT_OPEN = `${namespace}ChatbotOpened`;
export const INVESTOR_VIEW_SECTOR_REPORT = `${namespace}ViewSectorReport`;
export const INVESTOR_OPEN_NEWS_ARTICLE = `${namespace}OpenNewsArticle`;
export const INVESTOR_OPEN_COMPANY_WEBSITE = `${namespace}OpenCompanyWebsite`;
export const INVESTOR_CHARTS_CLICK = `${namespace}ViewChartsClicked`;
export const INVESTOR_TABLE_CLICK = `${namespace}ViewTablesClicked`;
export const INVESTOR_OPEN_ADD_TO_WATCHLIST = `${namespace}OpenAddToWatchlist`;
export const INVESTOR_ADD_TO_WATCHLIST_CLICK = `${namespace}AddToWatchlistClick`;
export const INVESTOR_VIEW_AICA_SAMPLE_REPORT = `${namespace}ViewAicaSampleReport`;
export const INVESTOR_AICA_ADD_USER = `${namespace}AicaAddUser`;
export const AICA_INVITE_USER = `Aica_InviteUser`;
export const INVESTOR_MANAGE_TEAM = `${namespace}manageTeam`;
export const INVESTOR_MANAGE_PARTNER = `${namespace}managePartner`;
export const INVESTOR_MANAGE_INVESTORS = `${namespace}manageInvestors`;

export const AICA_PARTNER_SUMMON = `Partner_Summon`;

export const AICA_RELATED_PARTY = `${namespace}AICA_Related_Party`;
export const AICA_REVENUE_CHARTS = `${namespace}AICA_Revenue_Charts`;
export const AICA_REVENUE_TABLE = `${namespace}AICA_Revenue_Table`;
export const AICA_VENDOR_CHARTS = `${namespace}AICA_Vendor_Charts`;
export const AICA_VENDOR_TABLE = `${namespace}AICA_Vendor_table`;

export const UNDERWRITER_SUMMON_AICA = 'Underwriter_SummonAica';
export const RRF_VIEW_AICA_REPORT = 'RRFInvestor_View_Aica_Report';
export const AICA_DOWNLOAD_DATA = `${namespace}AICA_Download_Data`;

export const AICA_PARTNERS_LOGINOTP = `${namespace}AICA_Partners_LoginOTP`;
export const AICA_PARTNERS_LOGIN = `${namespace}AICA_Partners_Login`;
export const AICA_INVESTOR_FORGOT_PASSWORD = `${namespace}_ForgotPassword`;
export const AICA_PARTNERS_SIGNUP = `${namespace}AICA_Partners_Signup`;
export const AICA_PARTNERS_SUBMIT_DETAILS = `${namespace}AICA_Partners_Submitdetails`;

export const AICA_ADD_PROSPECT = `${namespace}AICA_Add_Prospect`;
export const AICA_ADD_LEAD = `${namespace}AICA_Add_Lead`;
export const AICA_CASHFLOW_BANKING = `${namespace}CashflowBanking`;
export const AICA_INVESTOR_UPLOAD_DATA = `${namespace}Upload_Data`;
export const AICA_DATA_ROOM_OPENED = `${namespace}AICA_Data_Room_Opened`;
export const AICA_DATA_ROOM_FILE_VIEWED = `${namespace}AICA_Data_Room_File_Viewed`;
export const AICA_DATA_ROOM_FILE_DOWNLOADED = `${namespace}AICA_Data_Room_File_Downloaded`;
export const AICA_DATA_ROOM_NEW_FILE_DOWNLOADED = `${namespace}AICA_Data_Room_New_File_Downloaded`;
export const AICA_GENERATE_INVESTMENT_REPORT = `AICA_Generate_IR`;

export const AICA_GENERATE_ONE_PAGER = `AICA_Generate_Onepager`;
export const AICA_ONEPAGER_CLOSED = `AICA_Onepager_Closed`;
export const AICA_ONEPAGER_PREVIEW = `AICA_Onepager_Preview`;
export const AICA_ONEPAGER_REGENERATE = `AICA_Onepager_Regenerate`;
export const AICA_ONEPAGER_VIEW = `AICA_Onepager_View`;
export const AICA_ONEPAGER_EDIT = `AICA_Onepager_Edit`;
export const AICA_ONEPAGER_VIEW_HISTORY = `AICA_Onepager_View_History`;
export const AICA_ONEPAGER_RESTORE_VERSION = `AICA_Onepager_Restore_Version`;

export const AICA_ENGAGEMENT_LETTER_VIEW = `AICA_View_Engagement_Letter`;
export const AICA_ENGAGEMENT_LETTER_EDIT = `AICA_Edit_Engagement_Letter`;
export const AICA_ENGAGEMENT_LETTER_PREVIEW = `AICA_Preview_Engagement_Letter`;
export const AICA_ENGAGEMENT_LETTER_SAVE = `AICA_Save_Engagement_Letter`;
export const AICA_BUREAU_KYC_CONSENT_EDIT = `AICA_Edit_Bureau_Consent_Letter`;
export const AICA_BUREAU_KYC_CONSENT_VIEW = `AICA_View_Bureau_Consent_Letter`;
export const AICA_NDA_VIEW = `AICA_View_NDA`;
export const AICA_NDA_EDIT = `AICA_Edit_NDA`;
export const AICA_NDA_PREVIEW = `AICA_Preview_NDA`;
export const AICA_NDA_SAVE = `AICA_Save_NDA`;

export const AICA_CREATE_DEAL = 'AICA_Create_Deal';
export const AICA_EDIT_DEAL = `AICA_Edit_Deal`;
export const AICA_SHARE_DEAL = `AICA_Share_Deal`;

export const AICA_UNLOCK_REFRESH_OPENED = `AICA_Unlock_Refresh_Opened`;
export const AICA_UNLOCK_REFRESH_UPDATE = `AICA_Clicked_Update_Unlock_Refresh`;

export const AICA_DATAROOM_FILE_DOWNLOAD = `Investor_AICA_Data_Room_Individual_File_Downloaded`;
export const AICA_DATAROOM_FILE_DELETE = `Investor_AICA_Data_Room_Delete_File`;
export const AICA_DATAROOM_FILE_ARCHIVE = `Investor_AICA_Data_Room_Archive_File`;
export const AICA_DATAROOM_FILE_MOVE = `Investor_AICA_Data_Room_Move_File`;
export const AICA_DATAROOM_FILE_SAVE_MOVED = `Investor_AICA_Data_Room_Save_Move_File`;
export const AICA_DATAROOM_BULK_ACTION_COMPLETED = `data_room_bulk_action_completed`;

export const AICA_FINANCIAL_METRICS = 'AICA_Financial_Metrics';
export const AICA_RELATED_PARTY_ALERTS = 'Aica_Related_Party_Alerts';
export const AICA_RELATED_PARTY_RELATIONSHIP = 'Aica_Related_Party_Relationships';
export const AICA_VIEW_DETAILS = 'AICA_View_Details';
export const AICA_GENERATE_PDF_REPORT = 'AICA_generate_pdf_report';

export const VIEW_DEBT_PRODUCTS_PAGE = 'View_Debt_Products_Page';
export const SELECT_PRODUCT = 'Select_Product';
export const EXPAND_PRODUCT = 'Expand_Product';
export const SELECT_LENDER = 'Select_Lender';
export const CLICK_PROBABILITY_HELP = 'Click_Probability_Help';
export const OPEN_EDIT_PROFILE = 'Open_Edit_Profile';
export const APPLY_FILTERS = `Apply Filters`;
export const CLEAR_FILTERS = `Clear Filters`;
export const CLICKED_ADD_FILTERS = `Clicked Add Filters`;

export const INVESTOR_COMMENT_ADDED = `Comment_Added`;
export const COMMENT_EDIT = `Comment_Edit`;
export const COMMENT_SAVE = `Comment_Save`;
export const COMMENT_DELETE = `Delete_Comment`;
export const COMMENT_DELETE_CONFIRM = `Delete_Comment_Confirm`;
export const AICA_VIEW_COMMENT = `AICA_View_Comment`;
export const AICA_VIEW_COMMENT_DEALS = `AICA_View_Comment_Deals`;
export const AICA_ADD_COMMENT = `AICA_Add_Comment`;

export const AICA_MAGIC_UPLOAD = `AICA_Magic_Upload`;
export const AICA_DATAROOM_MAGIC_UPLOAD = `Dataroom_Magic_Upload`;
export const AICA_DATA_PENDING = `AICA_Data_Pending`;
export const AICA_DATA_PENDING_REMINDER = `AICA_Data_Pending_Send_Reminder`;
export const AICA_DATA_PENDING_CLARIFICATION = `Company_Add_Clarification`;
export const AICA_DATA_PENDING_EDIT = `Company_Data_Pending_Clarification_Edit`;
export const AICA_DATA_PENDING_ADD_ITEM = `Company_Data_Pending_Add_Item`;
export const AICA_LIST_PAGE_VIEW_BUREAU_ENQUIRY_DRAWER = `AICA_List_Page_View_Bureau_Enquiry_Drawer`;

export const AICA_LEGAL_CASE_DOWNLOAD = `AICA_downloadCase_Details`;
export const AICA_LEGAL_CASE_DOWNLOAD_ALL = `Legal_Case_Report_Download_all_Clicked`;

//COMPANIES LIST FILTERS
export const COMPANIES_LIST_FILTER_DRAWER_OPENED = `Companies_List_Filter_Drawer_Opened`;
export const COMPANIES_LIST_FILTER_VALUE_SELECTED = `Companies_List_Filter_Value_Selected`;
export const COMPANIES_LIST_FILTER_VALUE_APPLIED = `Companies_List_Filter_Applied`;
export const COMPANIES_LIST_FILTER_VALUE_CLEARED = `Companies_List_Clear_All_Filters`;
export const COMPANIES_LIST_DELETE_FILTERS_FROM_OUTSIDE = `Companies_List_Delete_Filters_From_Outside`;

//SORTING
export const SORT_CLICKED = `Sort_Clicked`;

//ASK AICA
export const AICA_ASK_AICA_MODAL_OPENED = `AICA_Ask_Aica_Modal_Opened`;
export const AICA_ASK_AICA_MESSAGE_SENT = `AICA_Ask_Aica_Message_Sent`;
export const AICA_ASK_AICA_SUGGESTION_CLICKED = `AICA_Ask_Aica_Suggestion_Clicked`;

//TALK_TO_US
export const Talk_To_Us = `Talk_To_Us_Modal_Opened`;

//VIEW ACCOUNT / SUMMON
export const BORROWER_SUMMON = `Borrower_Summon`;

//BULK_ADD
export const BULK_ADD = `BULK_ADD`;
export const BULK_ADD_CONFIRM = `BULK_ADD_CONFIRM`;

export const AICA_MANDATE_SELECTION = `AICA_Mandate_Selection`;
export const AICA_UPDATE_MANDATE = `AICA_Update_Mandate`;
export const AICA_FILTERS_ON_DEBT_OPTIONS = `AICA_Filters_on_Debt_Options`;
export const AICA_ONE_PAGER_ATTACHMENT = 'AICA_One_Pager_Attachment';
export const AICA_EMAIL_ATTACHMENT = 'AICA_Email_Attachment';
export const AICA_EDIT_TERMS = 'AICA_Edit_Terms';

//COMPANY NETWORK
export const AICA_NETWORK_DRAWER_OPENED = `AICA_NetworkDrawer_Opened`;
export const AICA_NETWORK_FILTER_APPLIED = `AICA_NetworkFilter_Applied`;

//RECONCILIATION FILTERS
export const AICA_RECON_FILTER_APPLIED = `AICA_RECON_FILTER_APPLIED`;

//AUDITOR COMMENTS
export const AICA_AUDITOR_COMMENTS_PILL_CLICKED = `AICA_Auditor_Comments_Pill_Clicked`;
